<template>
  <v-container fluid class="home pt-0">
    <v-row justify="center" class="display-home-main pa-5 pa-md-0">
      <v-col cols="12" class="pt-5">
        <MainCards />
      </v-col>
    </v-row>
    <v-row>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="8">
            <v-card class="plot-card ma-3">
              <v-card-title class="pa-3">
                  <v-icon  class="text-white"> bar_chart </v-icon>
                  {{ $t('display/dashboard:labels.playouts-30-days') }}
              </v-card-title>
              <v-card-text>
                <iframe
                    src="https://statistic.gratis-notruf.com/public/question/33bef22b-2ffc-441a-a0dd-d317b555d714"
                    width="100%"
                    height="600"
                    allowtransparency
                ></iframe>
              </v-card-text>
            </v-card>

            <v-card class="plot-card ma-3">
              <v-card-title class="pa-3">
                  <v-icon  class="text-white"> bar_chart </v-icon>
                  {{ $t('display/dashboard:labels.most-played-adverts') }}
              </v-card-title>
              <v-card-text>
                <iframe
                    src="https://statistic.gratis-notruf.com/public/question/9ba70224-0fa9-40f9-bd6e-52bdae4daba5"
                    width="100%"
                    height="600"
                    allowtransparency
                ></iframe>
              </v-card-text>
            </v-card>

            <v-card class="plot-card ma-3">
              <v-card-title class="pa-3">
                  <v-icon  class="text-white"> bar_chart </v-icon>
                  {{ $t('display/dashboard:labels.elevator-playouts') }}
              </v-card-title>
              <v-card-text>
                <iframe
                    src="https://statistic.gratis-notruf.com/public/question/667f87cc-d7b7-4989-8a01-e3f29b9acb92"
                    width="100%"
                    height="600"
                    allowtransparency
                ></iframe>
              </v-card-text>
            </v-card>

            <v-card class="plot-card ma-3">
              <v-card-title class="pa-3">
                  <v-icon  class="text-white"> bar_chart </v-icon>
                  {{ $t('display/dashboard:labels.offline-stats-30-days') }}
              </v-card-title>
              <v-card-text>
                <iframe
                    src="https://statistic.gratis-notruf.com/public/dashboard/79ee981a-7ecc-42fd-9b61-97c8f16b81cd"
                    width="100%"
                    height="600"
                    allowtransparency
                ></iframe>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-card class="plot-card ma-3">
              <v-card-title class="pa-3">
                  <v-icon  class="text-white"> notifications </v-icon>
                  {{ $t('display/dashboard:labels.emergencies') }}
              </v-card-title>
              <v-card-text>
                <DashboardCard
                    link="emergency"
                    showLink
                    :cardType="$t('display/dashboard:labels.emergencies')"
                />
                <v-btn
                    outlined
                    color="primary"
                    class="full-width mt-3"
                    @click="$emit('goTotal')"
                > {{ $t('display/dashboard:labels.view-all-emergencies') }} </v-btn>
              </v-card-text>
            </v-card>
            <v-card class="plot-card ma-3">
              <v-card-title class="pa-3">
                  <v-icon  class="text-white"> mobile_off </v-icon>
                  {{ $t('display/dashboard:labels.offline-devices') }}
              </v-card-title>
              <v-card-text>
                <DashboardCard
                    link="offline"
                    showLink
                    :cardType="$t('display/dashboard:labels.offline-devices')"
                />
              </v-card-text>
            </v-card>
            <v-card class="plot-card ma-3">
              <v-card-title class="pa-3">
                  <v-icon  class="text-white"> new_releases </v-icon>
                  {{ $t('display/dashboard:labels.new-devices') }}
              </v-card-title>
              <v-card-text>
                <DashboardCard
                    link="new"
                    :cardType="$t('display/dashboard:labels.new-devices')"
                />
              </v-card-text>
            </v-card>
            <v-card class="plot-card ma-3">
              <v-card-title class="pa-3">
                  <v-icon  class="text-white"> pie_chart </v-icon>
                  {{ $t('display/dashboard:labels.client-version') }}
              </v-card-title>
              <v-card-text>
                <iframe
                    src="https://statistic.gratis-notruf.com/public/question/29d3cb2a-a210-4f44-b646-d83dbdc921ef"
                    width="100%"
                    height="600"
                    allowtransparency
                ></iframe>
              </v-card-text>
            </v-card>
            <v-card class="plot-card ma-3">
              <v-card-title class="pa-3">
                  <v-icon  class="text-white"> pie_chart </v-icon>
                  {{ $t('display/dashboard:labels.client-channels') }}
              </v-card-title>
              <v-card-text>
                <iframe
                    src="https://statistic.gratis-notruf.com/public/question/ab507112-e700-4f7c-bb65-9ad9a0a102f3"
                    width="100%"
                    height="600"
                    allowtransparency
                ></iframe>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
  </v-container>
</template>

<script>

import DashboardCard from '@/modules/display/views/home/dashboard/DashboardCard';
import MainCards from "@/modules/display/views/home/dashboard/MainCards";

export default {
  name: "DisplayDashboard",
  components: {MainCards, DashboardCard}
}
</script>

<style src="./Dashboard.scss" lang="scss"/>
